angular.module('tgaApp').controller('TutorialController', [
  '$scope',
  'settingsService',
  'analyticsService',
  'gameConfig',
  'soundService',
  function ($scope, settingsService, analyticsService, gameConfig, soundService) {
    $scope.tutorial = {
      tutorialIndex: 1,
      tutorialLength: 5,
      tutorialTime: 0,
      position: 0,
      indexes: [],
    };

    $scope.initialize = function () {
      // tmp skip tutorial
      $scope.tutorialStartTime = Date.now();
    };
    // Conditionally changes order of tutorial pages based on admin choices
    if (!$scope.gameData.data.metering && !$scope.game.enable_question_history) {
      $scope.tutorial.indexes = [1, 4, 5];
    } else if (!$scope.gameData.data.metering) {
      $scope.tutorial.indexes = [1, 3, 4, 5];
    } else if (!$scope.game.enable_question_history) {
      $scope.tutorial.indexes = [1, 2, 4, 5];
    } else {
      $scope.tutorial.indexes = [1, 2, 3, 4, 5];
    }

    $scope.actions = {
      changeTutorialIndex(increment) {
        if (!gameConfig.sfx_muted) {
          soundService.play('click');
        }
        if (increment) {
          $scope.tutorial.position = $scope.tutorial.indexes.indexOf($scope.tutorial.tutorialIndex);

          if ($scope.tutorial.position >= 0 && $scope.tutorial.position < $scope.tutorial.indexes.length) {
            $scope.tutorial.tutorialIndex = $scope.tutorial.indexes[$scope.tutorial.position + 1];
          }

          $scope.analyticsService.sendEvent({
            category: 'player action',
            action: 'button clicked',
            label: 'next',
          });
        } else {
          $scope.tutorial.tutorialIndex--;
          $scope.analyticsService.sendEvent({
            category: 'player action',
            action: 'button clicked',
            label: 'back',
          });
        }
      },
      endTutorial() {
        $scope.tutorial.tutorialTime = Date.now() - $scope.tutorialStartTime;
        $scope.tutorialButon.endTutorial();
        $scope.analyticsService.sendTimingEvent({
          category: 'tutorial',
          var: 'time_spent',
          value: $scope.tutorial.tutorialTime,
        });
        // do we need to reset the tutorial data for when you restart from the menu?
        // start game...
      },
    };

    // init
    $scope.initialize();
  },
]);
